import { jsxs as l, jsx as h } from "react/jsx-runtime";
const z = ({ size: v }) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: v, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ h(
    "path",
    {
      fill: "#1ABF74",
      d: "m594.944 0 335.124 341.32v563.2c0 65.996-52.5 119.48-117.294 119.48H209.546c-64.793 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.757 0 209.551 0h385.393z"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      fill: "#FFF",
      fillOpacity: 0.4,
      d: "M930.068 341.32H718.152c-64.748 0-123.208-59.49-123.208-125.492V0l335.124 341.32z"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      fill: "#FFF",
      d: "M594.616 426.824v.23h.092V768h-27.873v-.051h-83.968.046-83.143.05-139.919v-28.39l.052-.047v-85.826h-.052V625.29h.052v-85.826h-.098v-28.396l.093-.046v-55.854h-.093v-28.39h334.71l.046.046zM371.988 653.686h-84.106v85.826h84.106v-85.826zm83.083 0h-55.245v85.826h55.199v-85.826h.05zm111.76 0h-83.923v85.826h83.876v-85.826h.046zM371.987 539.459h-84.106v85.831h84.106v-85.826zm83.083 0h-55.245v85.831h55.199v-85.826h.05zm111.76 0h-83.923v85.831h83.876v-85.826h.046zm0-84.245H287.881v55.808h278.902v-55.854l.046.051z"
    }
  )
] });
export {
  z as ExcelIcon
};
//# sourceMappingURL=ExcelIcon.js.map
